const { InspectorControls } = wp.blockEditor
const { PanelBody, SelectControl, ToggleControl } = wp.components
import CommonPanel from '../wp-controlers/common-panel'

const Inspector = ({ attributes, setAttributes }) => {
  const { horizontal } = attributes

  return (
    <InspectorControls>
      <PanelBody title="Atributos do Bloco" initialOpen={true}>
        <ToggleControl
          label="O forms é na horizontal?"
          checked={horizontal}
          onChange={() => setAttributes({ horizontal: !horizontal })}
        />
      </PanelBody>

      <CommonPanel attributes={attributes} setAttributes={setAttributes} />
    </InspectorControls>
  )
}

export default Inspector
